'use client';

import { Suspense } from 'react';

// Both import statically: the chain is hooks + zustand only (no upload libs),
// and next/dynamic is incompatible with instant-shell validation under
// cacheComponents — ssr:false CSR-bails its subtree (even inside Suspense),
// and ssr:true suspends the lazy boundary during prerender.
import { UploadProvider } from '@/shared/components/providers/upload-provider';
import { GlobalUploadIndicator } from '@/shared/components/upload/GlobalUploadIndicator';

export function LazyUploadScope({ children }: { children: React.ReactNode }) {
  return (
    <UploadProvider>
      {children}
      {/* Suspense keeps the indicator's usePathname() read out of the static
          shell (floating UI, renders null unless uploads are active). */}
      <Suspense>
        <GlobalUploadIndicator />
      </Suspense>
    </UploadProvider>
  );
}
